<div class="filter-container">
  <div class="block-title">
    <div class="h4 m-0">Filter</div>
    <button type="button" class="close" (click)="closePanel()">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
        <rect width="28" height="28" rx="6" fill="none" />
        <g transform="translate(4 4)">
          <rect width="20" height="20" fill="none" />
          <path d="M10,11.229,5.979,15.25a.789.789,0,0,1-.6.24.863.863,0,0,1-.6-.261.88.88,0,0,1,0-1.229l4-4L4.75,5.979a.8.8,0,0,1-.24-.614.875.875,0,0,1,.261-.615A.88.88,0,0,1,6,4.75l4,4.021L14.021,4.75A.869.869,0,0,1,15.25,5.979L11.229,10l4.021,4.021a.855.855,0,0,1,0,1.208.88.88,0,0,1-1.229,0Z"
                transform="translate(-0.005 0.005)" fill="#757575" />
        </g>
      </svg>
    </button>
  </div>
  <div class="filter-detail">
    <div class="select-options custom-dropdown">
      <label class="input-label" for="">
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.65136 15C6.40008 15 6.18982 14.9153 6.02058 14.7461C5.85135 14.5769 5.76673 14.3666 5.76673 14.1153V8.32688L0.168684 1.21538C-0.0236161 0.95896 -0.0514992 0.692293 0.0850341 0.415376C0.221567 0.13846 0.452009 0 0.776359 0H13.7571C14.0814 0 14.3119 0.13846 14.4484 0.415376C14.5849 0.692293 14.557 0.95896 14.3647 1.21538L8.76668 8.32688V14.1153C8.76668 14.3666 8.68207 14.5769 8.51283 14.7461C8.3436 14.9153 8.13334 15 7.88206 15H6.65136ZM7.26671 7.79998L12.2167 1.49998H2.31671L7.26671 7.79998Z" fill="#0068D8"/>
        </svg>
        Saved Filters
      </label>
      <div class="select-block">
        <ng-select [searchable]="true" [clearable]="false" [(ngModel)]="selectedFilter" placeholder="Saved Filters" (change)="onSaveFilterChange($event)" class="form-control">
          <ng-option *ngFor="let item of filterList" [value]="item.filterId">
            <span class="overflow-list-item">{{item.name}} </span>
            <span class="right-data">
              <span *ngIf="item.default"> <span class="filter-type"> (</span>Default<span class="filter-type">)</span></span>
              <span *ngIf="item.public"> <span class="filter-type"> (</span>Public<span class="filter-type">)</span></span>
              <a href="javascript:void(0)" (click)="deleteFilter(item.filterId)">
                <svg class="delete-item {{item.filterId}}" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path class="delete-item {{item.filterId}}"
                        d="M7.3 20.5C6.8 20.5 6.375 20.325 6.025 19.975C5.675 19.625 5.5 19.2 5.5 18.7V6H5.25C5.03333 6 4.85433 5.929 4.713 5.787C4.571 5.64567 4.5 5.46667 4.5 5.25C4.5 5.03333 4.571 4.85433 4.713 4.713C4.85433 4.571 5.03333 4.5 5.25 4.5H9C9 4.25 9.08733 4.04167 9.262 3.875C9.43733 3.70833 9.65 3.625 9.9 3.625H14.1C14.35 3.625 14.5627 3.70833 14.738 3.875C14.9127 4.04167 15 4.25 15 4.5H18.75C18.9667 4.5 19.146 4.571 19.288 4.713C19.4293 4.85433 19.5 5.03333 19.5 5.25C19.5 5.46667 19.4293 5.64567 19.288 5.787C19.146 5.929 18.9667 6 18.75 6H18.5V18.7C18.5 19.2 18.325 19.625 17.975 19.975C17.625 20.325 17.2 20.5 16.7 20.5H7.3ZM7 6V18.7C7 18.7833 7.02933 18.8543 7.088 18.913C7.146 18.971 7.21667 19 7.3 19H16.7C16.7833 19 16.8543 18.971 16.913 18.913C16.971 18.8543 17 18.7833 17 18.7V6H7ZM9.4 16.25C9.4 16.4667 9.471 16.646 9.613 16.788C9.75433 16.9293 9.93333 17 10.15 17C10.3667 17 10.546 16.9293 10.688 16.788C10.8293 16.646 10.9 16.4667 10.9 16.25V8.75C10.9 8.53333 10.8293 8.354 10.688 8.212C10.546 8.07067 10.3667 8 10.15 8C9.93333 8 9.75433 8.07067 9.613 8.212C9.471 8.354 9.4 8.53333 9.4 8.75V16.25ZM13.1 16.25C13.1 16.4667 13.1707 16.646 13.312 16.788C13.454 16.9293 13.6333 17 13.85 17C14.0667 17 14.246 16.9293 14.388 16.788C14.5293 16.646 14.6 16.4667 14.6 16.25V8.75C14.6 8.53333 14.5293 8.354 14.388 8.212C14.246 8.07067 14.0667 8 13.85 8C13.6333 8 13.454 8.07067 13.312 8.212C13.1707 8.354 13.1 8.53333 13.1 8.75V16.25ZM7 6V18.7C7 18.7833 7.02933 18.8543 7.088 18.913C7.146 18.971 7.21667 19 7.3 19H7V6Z"
                        fill="#D80000" />
                </svg>
              </a>
            </span>
          </ng-option>
        </ng-select>

        <!-- <ng-select name="savedFilterList" [items]="filterList"
                       bindLabel="name"
                       bindValue="filterId"
                       [(ngModel)]="selectedFilter" placeholder="Saved Filters" class="form-control" (change)="onSaveFilterChange($event)">
        </ng-select> -->
        <!-- <a href="javascript:void(0)" (click)="deleteFilter()">Delete Filter</a> -->
      </div>
    </div>
    <div class="table-selection-block" *ngIf="filterCategory != filterCategoryProducer">
      <div class="row">
        <div class="{{filterCategory == IndividualBulkLicenseRenewal ? 'col-md-12' : 'col-md-8'}}">
          <div class="select-options">
            <label class="input-label" for="">State</label>
            <div class="select-block multi-bor-0 width-auto state-common-fillter">
              <ng-multiselect-dropdown name="statesSelected" [placeholder]="'State'" class="form-control" [settings]="dropdownSettingState" [data]="states" [(ngModel)]="selectedStates">
              </ng-multiselect-dropdown>
            </div>
          </div>
        </div>
        <div class="col-md-4" *ngIf="filterCategory != IndividualBulkLicenseRenewal">
          <div class="select-options">
            <label class="input-label" for="">Status</label>
            <div class="select-block">
              <ng-select [searchable]="true" [clearable]="true" placeholder="Status" name="status" class="form-control" [(ngModel)]="selectedStatus">
                <ng-option value="null">All</ng-option>
                <ng-option *ngFor="let LStatus of licenseStatusList" [value]="LStatus.status">
                  {{ LStatus.status }}
                </ng-option>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="col-md-12" *ngIf="filterCategory == 2 || filterCategory == 4">
          <div class="select-options">
            <label class="input-label" for="">License class</label>
            <div class="select-block multi-bor-0 width-auto">
              <ng-multiselect-dropdown name="licenseClassSelected" class="form-control"
                                       [placeholder]="'License class'" [settings]="dropdownSettingLicenseClass" [data]="licenseClasses" [(ngModel)]="selectedLicenseClasses">
              </ng-multiselect-dropdown>
            </div>
          </div>
        </div>
        
        <div class="col-md-12" *ngIf="filterCategory == 3">
          <div class="select-options">
            <label class="input-label" for="">LOA</label>
            <div class="select-block multi-bor-0 width-auto">
              <ng-multiselect-dropdown class="form-control" name="appointmentTypeListSelected"
                                       [placeholder]="'LOA'" [settings]="dropdownSettingAppointType" [data]="appointmentTypeList"
                                       [(ngModel)]="selectedAppointmentTypeList">
              </ng-multiselect-dropdown>
            </div>
          </div>
        </div>
        <div class="col-md-12" *ngIf="!isContactUser">
          <div class="select-options">
            <label class="input-label" for="">{{tenantTypeId == 3 ? 'Branch':'Agency'}}</label>
            <div class="select-block">
              <ng-select [searchable]="true" [clearable]="true" placeholder="{{tenantTypeId == 3 ? 'Branch':'Agency'}}"
                         name="branch" class="form-control min-height" [(ngModel)]="selectedBranchId">
                <ng-option [value]=0>All</ng-option>
                <ng-option *ngFor="let branch of branchList" [value]="branch.branchId">{{branch.branchName}}</ng-option>
              </ng-select>
            </div>
          </div>
        </div>
       
        <div class="col-md-4" *ngIf="filterCategory == 2">
          <div class="select-options right">
            <label class="input-label" for="">Renewal due</label>
            <div class="select-block renewal-due">
              <ng-select [searchable]="true" [clearable]="true" placeholder="Renewal due" name="expireIn" class="form-control" [(ngModel)]="selectedExpireIn">
                <ng-option *ngFor="let days of expiryInData" [value]="days.id">{{days.days}}</ng-option>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="col-md-4" *ngIf="filterCategory == 3">
          <div class="select-options right">
            <label class="input-label" for="">Expires In</label>
            <div class="select-block">
              <ng-select [searchable]="true" [clearable]="true" placeholder="Expires in" name="expireIn" class="form-control" [(ngModel)]="selectedExpireIn">
                <ng-option *ngFor="let days of expiryInData" [value]="days.id">{{days.days}}</ng-option>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="col-md-4" *ngIf="filterCategory == 2 ">
          <div class="select-options right">
            <label class="input-label" for="">Resident type</label>
            <div class="select-block">
              <ng-select [searchable]="true" [clearable]="true" placeholder="Resident type" name="residentTypeCode" class="form-control" [(ngModel)]="selectedResidentTypeCode">
                <ng-option value="null">All</ng-option>
                <ng-option *ngFor="let type of residentTypeList" [value]="type.id">{{type.type}}</ng-option>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="col-md-4" *ngIf="!isContactUser && (filterCategory == 2 || filterCategory == 3)">
          <div class="select-options right">
            <label class="input-label" for="">User type</label>
            <div class="select-block">
              <ng-select [searchable]="true" [clearable]="true" placeholder="User type" name="npnType" class="form-control" [(ngModel)]="selectedNPNType">
                <ng-option value="null">All</ng-option>
                <ng-option *ngFor="let type of userTypeList" [value]="type.id">{{type.type}}</ng-option>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="col-md-12" *ngIf="!isContactUser && filterCategory == 3">
          <div class="select-options">
            <label class="input-label" for="">{{tenantTypeId == 1 ? 'Agent': 'Producer'}}</label>
            <div class="select-block tag-block multi-bor-0 width-auto" (click)="scrolltoBottom('contact')">
              <ng-multiselect-dropdown id="contact" class="form-control" name="selectedContactList"
                                       placeholder="{{tenantTypeId == 1 ? 'Agent': 'Producer'}}" [settings]="dropdownSettingActiveContactList"
                                       [data]="activeContactList"
                                       [(ngModel)]="selectedContactList">
              </ng-multiselect-dropdown>
            </div>
          </div>
        </div>
        <!--<div class="col-md-6">
    <div class="select-options">
      <label for="">{{tenantTypeId == 1 ? 'Producer':'Agent'}}</label>
      <div class="select-block">
        <ng-select [searchable]="true" [clearable]="true" placeholder="{{tenantTypeId == 1 ? 'Producer':'Agent'}}"
                   name="contact" class="form-control min-height" [(ngModel)]="selectedContactId">
          <ng-option [value]=0>All</ng-option>
          <ng-option *ngFor="let contact of activeContactList" [value]="contact.contactId">{{contact.contactName}}</ng-option>
        </ng-select>
      </div>
    </div>
  </div>-->
        <div class="col-md-12" *ngIf="filterCategory == 3">
          <div class="select-options">
            <label class="input-label" for="">Carrier  
              <span *ngIf="isMGAUser" class="tooltip-icon carrier-filter pl-1" style="top: -5px;">
                  <svg xmlns="http://www.w3.org/2000/svg" id="ic-info" width="20" height="20" viewBox="0 0 24 24">
                    <rect id="Rectangle_18062" data-name="Rectangle 18062" width="24" height="24" fill="none" />
                    <path id="info_FILL0_wght300_GRAD0_opsz24" d="M12,16.75a.725.725,0,0,0,.75-.75V11.725a.7.7,0,0,0-.212-.513.751.751,0,0,0-1.288.538v4.275a.7.7,0,0,0,.213.513A.728.728,0,0,0,12,16.75ZM12,9.3a.757.757,0,0,0,.575-.238.82.82,0,0,0,.225-.587.792.792,0,0,0-.225-.563.816.816,0,0,0-1.15,0,.792.792,0,0,0-.225.563.82.82,0,0,0,.225.587A.757.757,0,0,0,12,9.3Zm0,12.2a9.263,9.263,0,0,1-3.712-.75A9.432,9.432,0,0,1,3.25,15.712a9.563,9.563,0,0,1,0-7.425A9.435,9.435,0,0,1,8.288,3.25a9.563,9.563,0,0,1,7.425,0A9.437,9.437,0,0,1,20.75,8.287a9.563,9.563,0,0,1,0,7.425,9.435,9.435,0,0,1-5.037,5.038A9.27,9.27,0,0,1,12,21.5ZM12,12Zm0,8a7.714,7.714,0,0,0,5.663-2.337A7.714,7.714,0,0,0,20,12a7.714,7.714,0,0,0-2.337-5.663A7.714,7.714,0,0,0,12,4,7.711,7.711,0,0,0,6.338,6.337,7.713,7.713,0,0,0,4,12a7.713,7.713,0,0,0,2.338,5.663A7.711,7.711,0,0,0,12,20Z" fill="#0068D8" />
                  </svg>
                  <span class="text-tooltip" style="max-width: 290px; white-space: break-spaces;">
                    Your Contracted carriers are selected here by default.
                  </span>
                </span>
            </label>
            <div class="select-block tag-block multi-bor-0 width-auto" (click)="scrolltoBottom('carrier')">
              <ng-multiselect-dropdown id="carrier" class="form-control" name="selectedCarrierList"
                                       [placeholder]="'Carrier'" [settings]="dropdownSettingCarrierList"
                                       [data]="carrierList"
                                       [(ngModel)]="selectedCarrierList">
              </ng-multiselect-dropdown>
            </div>
            <!--<div class="select-block">
              <ng-select [searchable]="true" [clearable]="true" placeholder="Carrier"
                         name="carrier" class="form-control" [(ngModel)]="selectedCarrierId">
                <ng-option [value]=0>All</ng-option>
                <ng-option *ngFor="let carrier of carrierList" [value]="carrier.carrierId">{{carrier.carrierName}}</ng-option>
              </ng-select>
            </div>-->
          </div>
        </div>
        <div class="col-md-12" *ngIf="!isContactUser && filterCategory != 4">
          <div class="select-options">
            <label class="input-label" for="">Tag</label>
            <div class="select-block tag-block multi-bor-0 width-auto" (click)="scrolltoBottom('tag')">
              <ng-multiselect-dropdown id="tag" name="tagsSelected" [placeholder]="'Tag'" [hidden]="false" class="form-control" [settings]="dropdownSettingTag" [data]="tags" [(ngModel)]="selectedTags">
              </ng-multiselect-dropdown>
            </div>
          </div>
        </div>
        <div class="col-md-12" *ngIf="filterCategory == 3">
          <div class="select-options">
            <label class="input-label" for="">Line of business</label>
            <div class="select-block">
              <ng-select [searchable]="true" [clearable]="true" placeholder="Line of business"
                         name="lineOfBusiness" class="form-control" [(ngModel)]="selectedLineOfBusinessCarrierId">
                <ng-option selected [value]=0>All</ng-option>
                <ng-option *ngFor="let LOB of lineOfBusinessList" [value]="LOB.carrierId">{{LOB.lineofBusiness}}</ng-option>
              </ng-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-selection-block" *ngIf="filterCategory == filterCategoryProducer">
      <div class="row">
        <div class="col-md-12">
          <div class="select-options">
            <label class="input-label" for="">{{tenantTypeId == 3 ? 'Branch':'Agency'}}</label>
            <div class="select-block">
              <ng-select [searchable]="true" [clearable]="true" class="form-control" placeholder="{{tenantTypeId == 3 ? 'Branch':'Agency'}}" name="branchId" [(ngModel)]="branchId">
                <ng-option [value]="0" selected>All</ng-option>
                <ng-option *ngFor="let branch of branchList" [value]="branch.branchId">{{ branch.branchName }}</ng-option>
              </ng-select>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="select-options">
            <label class="input-label" for="">Department</label>
            <div class="select-block">
              <ng-select [searchable]="true" [clearable]="true" placeholder="Department"
                         class="form-control" [(ngModel)]="departmentId" name="departmentId">
                <ng-option [value]="0" selected>All</ng-option>
                <ng-option *ngFor="let department of departmentList" [value]="department.departmentID">{{ department.description }}</ng-option>
              </ng-select>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="select-options">
            <label class="input-label" for="">Status</label>
            <div class="select-block">
              <ng-select [searchable]="true" [clearable]="true" class="form-control" name="statusId" [(ngModel)]="tenantStatusId" placeholder="Status">
                <ng-option [value]="0" selected>All</ng-option>
                <ng-option *ngFor="let tenantStatus of tenantStatusList" [value]="tenantStatus.tenantStatusId">{{ tenantStatus.status }}</ng-option>
              </ng-select>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="select-options">
            <label class="input-label" for="">Tag</label>
            <div class="select-block tag-block multi-bor-0 width-auto" (click)="scrolltoBottom('tag')">
              <ng-multiselect-dropdown id="scrollTo" name="tagsSelected" [placeholder]="'Tag'" [hidden]="false" class="form-control"
                                       [settings]="dropdownSettingTag" [data]="tags" [(ngModel)]="selectedTags">
              </ng-multiselect-dropdown>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="select-options">
            <label class="input-label" for="">Resident state</label>
            <div class="select-block multi-bor-0 width-auto">
              <ng-multiselect-dropdown name="statesSelected" [placeholder]="'State'" class="form-control"
                                       [settings]="dropdownSettingResidentState" [data]="residentStateList" [(ngModel)]="selectedResidentStates">
              </ng-multiselect-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-button-group">
      <div class="left-btn d-flex">
        <button type="button" class="btn" style="margin-right: 10px;" (click)="openSaveFilterPopup()">
          Save Filter As
        </button>
        <button type="button" class="btn" *ngIf="this.selectedFilter != null" (click)="updateFilter()" [disabled]="isDisabled">Update Filter</button>
      </div>
      <div class="right-btn d-flex">
        <button class="border-btn" style="margin-right: 10px;" (click)="clearFilter()">Clear All</button>
        <button class="btn dark-btn" (click)="applyFilter()">Apply</button>
      </div>
    </div>
  </div>
</div>

<div class="modal-content new-appointment-model save-filter common-modal" id="savefilter" *ngIf="isSavePopup"
     style="z-index: 111;">
  <div class="modal-header pop-title">
    <h4 class="modal-title">Save Filter</h4>
    <button type="button" class="modal-close-btn close" data-dismiss="modal" (click)="closeSavePopup()">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
        <rect width="28" height="28" rx="6" fill="none" />
        <g transform="translate(4 4)">
          <rect width="20" height="20" fill="none" />
          <path d="M10,11.229,5.979,15.25a.789.789,0,0,1-.6.24.863.863,0,0,1-.6-.261.88.88,0,0,1,0-1.229l4-4L4.75,5.979a.8.8,0,0,1-.24-.614.875.875,0,0,1,.261-.615A.88.88,0,0,1,6,4.75l4,4.021L14.021,4.75A.869.869,0,0,1,15.25,5.979L11.229,10l4.021,4.021a.855.855,0,0,1,0,1.208.88.88,0,0,1-1.229,0Z"
                transform="translate(-0.005 0.005)" fill="#757575" />
        </g>
      </svg>
    </button>
  </div>
  <div class="modal-body">
    <div class="group-form">
      <form class="contactupdate-form" [formGroup]="saveFilterForm" id="saveFilterForm">
        <div class="row">
          <div class="col-12 col-sm-12">
            <div class="input-block">
              <label class="input-label" for="groupName">Save Filter Conditions As<span class="validation-field">*</span></label>
              <input type="text" class="form-control" maxlength="200" placeholder="Enter filter name" formControlName="filterName" name="filterName" />
            </div>
            <div class="check-group" *ngIf="loggedinUserRole != 'contact'">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" formControlName="default" id="default" name="default" (change)="onCheckboxChange($event)">
                <label class="custom-control-label" for="default">Default</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" formControlName="public" id="public" name="public" (change)="onCheckboxChange($event)">
                <label class="custom-control-label" for="public">Make Public</label>
              </div>
            </div>
            <!-- <div *ngIf="saveFilterForm.errors?.['requireCheckboxes'] && saveFilterForm.touched">
                <span class="validation-field">Please select defualt or public checkbox</span>
            </div> -->
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer px-0">
      <div class="action-btn-block justify-content-end">
        <button type="submit" class="btn basic-btn btn-md" (click)="closeSavePopup()">Cancel</button>
        <button type="submit" class="btn primary-btn btn-md" (click)="saveFilterChanges()">Save</button>
      </div>
    </div>
  </div>
</div>

<div class="modal-content new-appointment-model save-filter common-modal" id="deletefilter" *ngIf="isDeletePopup"
     style="z-index: 111;">
  <!-- tePopup()"> -->
  <div class="modal-header pop-title">
    <h4 class="modal-title">Delete Filter</h4>
    <button type="button" class="modal-close-btn close" data-dismiss="modal" (click)="closeDeletePopup()">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
        <rect width="28" height="28" rx="6" fill="none" />
        <g transform="translate(4 4)">
          <rect width="20" height="20" fill="none" />
          <path d="M10,11.229,5.979,15.25a.789.789,0,0,1-.6.24.863.863,0,0,1-.6-.261.88.88,0,0,1,0-1.229l4-4L4.75,5.979a.8.8,0,0,1-.24-.614.875.875,0,0,1,.261-.615A.88.88,0,0,1,6,4.75l4,4.021L14.021,4.75A.869.869,0,0,1,15.25,5.979L11.229,10l4.021,4.021a.855.855,0,0,1,0,1.208.88.88,0,0,1-1.229,0Z"
                transform="translate(-0.005 0.005)" fill="#757575" />
        </g>
      </svg>
    </button>
  </div>

  <!-- </button> -->

  <div class="modal-body">
    <div class="block-desc mt-2">
      <p>Are you sure you want to delete this filter?</p>
    </div>
    <div class="modal-footer">
      <div class="action-btn-block justify-content-end">
        <button type="submit" class="btn basic-btn btn-md" (click)="closeDeletePopup()">No</button>
        <button type="submit" class="btn danger-btn btn-md">Yes, Delete</button>
      </div>
    </div>
  </div>
</div>
